/**
 * tabs controller mixin
 */

/**
 * tabsCtrlMixinFactory
 * returns tabsCtrlMixin mixin factory
 *
 * @class tabsCtrlMixinFactory
 * @memberof mwApp/common
 * @see mwApp/common
 * @listens window.hashchange
 *
 * @ngdoc factory
 * @name mwApp/common.factory:tabsCtrlMixinFactory
 */
/* @ngInject */
export default function tabsCtrlMixinFactory ($location, $state, $timeout) {
  // In AngularJS there is no event for hash change,
  // and event '$locationChangeSuccess' emits every time location is changed, so it is not convenient to use it
  // So we add ordinary DOM 'hashchange' event listener to window
  var doNothing = false
  window.addEventListener('hashchange', function () {
    if (!doNothing) {
      var state = $state && $state.$current ? $state.$current : null
      if (state && state.locals) {
        for (var n in state.locals) {
          if (Object.prototype.hasOwnProperty.call(state.locals, n) && n.indexOf('@') === 0) {
            var view = state.locals[n]
            var scope = view ? view.$scope : null
            var vm = scope ? scope.vm : null

            if (vm && vm.setTab) {
              vm.setTab(true) // 'true' means 'set tab from hash'
              scope.$apply()
              break
            }
          }
        }
      }
    }
    doNothing = false
  })

  /**
   * Mixin with tabs manipulating
   *
   * @mixin tabsCtrlMixin
   * @memberof mwApp/common
   * @see mwApp/common
   * @name mwApp/common.mixin:tabsCtrlMixin
   *
   * @return {Object}
   */
  function tabsCtrlMixin () {
    // tabs array, given like arguments to mixin
    var tabs = Array.prototype.slice.call(arguments)

    return {
      _init: function () {
        var vm = this

        var hash = $state.restoreHash || $location.hash().trim()
        delete $state.restoreHash

        var activeTab = tabs.indexOf(hash)
        $timeout(function () {
          vm.activeTab = activeTab === -1 ? 0 : activeTab
          vm.activeTabName = tabs[vm.activeTab]
        }, 0)
      },
      setTab: function (fromHash) {
        var vm = this

        // set active tab number from hash value
        if (fromHash) {
          var activeTab = tabs.indexOf($location.hash().trim())
          vm.activeTab = activeTab === -1 ? 0 : activeTab
          vm.activeTabName = tabs[vm.activeTab]

        // set hash value from active tab number
        } else {
          $timeout(function () {
            // actually change hash only if it should be changed, i.e. not equal to active tab name
            if (tabs[vm.activeTab] !== $location.hash().trim()) {
              doNothing = true // flag to know, that we intentionally changed hash and don't need 'hashchange' event

              $location.hash(tabs[vm.activeTab])
              vm.activeTabName = tabs[vm.activeTab]
            }
          }, 0)
        }

        if (typeof vm.toChangeTab === 'function') {
          $timeout(function () {
            vm.toChangeTab(vm.activeTabName, vm.activeTab)
          }, 10)
        }
      }
    }
  }

  return tabsCtrlMixin
}
